import React, {useContext, useState} from 'react';
import {FormattedMessage} from "react-intl";

import CustomButton from "components/CustomButton";
import Badge from "components/Badge";

import MobileStatusesTab from "./MobileStatusesTab";
import ExportOrdersButton from "../../ExportOrdersButton";
import ExportLineItemsButton from "../../ExportLineItemsButton";
import FiltersDrawer from "./FiltersDrawer";

import {OrderListContext} from "views/oms/OrderList/context/OrderListContext";

const SettingIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.6667 4.33333H10.6667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4 4.33333H1.33333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.66667 6.66667C7.95533 6.66667 9 5.622 9 4.33333C9 3.04467 7.95533 2 6.66667 2C5.378 2 4.33333 3.04467 4.33333 4.33333C4.33333 5.622 5.378 6.66667 6.66667 6.66667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 11.6667H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.33333 11.6667H1.33333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.33333 14C10.622 14 11.6667 12.9553 11.6667 11.6667C11.6667 10.378 10.622 9.33333 9.33333 9.33333C8.04467 9.33333 7 10.378 7 11.6667C7 12.9553 8.04467 14 9.33333 14Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

// "Filtres" button (opens the mobile filters drawer) + compact export buttons
// + the status tabs, scrollable horizontally instead of the desktop tab row
function FiltersRow() {
    const [filtersOpen, setFiltersOpen] = useState(false);

    const {selectedFilters} = useContext(OrderListContext);

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px', backgroundColor: 'white', borderBottom: '1px solid #e6e7eb'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <div style={{flex: 1}}>
                    <CustomButton color={'blue'} fullWidth onClick={() => setFiltersOpen(true)}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'}}>
                            <FormattedMessage id='retailer.product.list.filter.title' />
                            {selectedFilters.length > 0 && (
                                <Badge color="default" size="small" rounded>
                                    {selectedFilters.length}
                                </Badge>
                            )}
                            <SettingIcon />
                        </div>
                    </CustomButton>
                </div>
                <ExportOrdersButton compact />
                <ExportLineItemsButton compact />
            </div>

            <MobileStatusesTab />

            <FiltersDrawer open={filtersOpen} onClose={() => setFiltersOpen(false)} />
        </div>
    );
}

export default FiltersRow;
